<div class="record-card-generic">
  <div class="record-card-generic__left">
    <ng-container [ngTemplateOutlet]="left.templateRef"></ng-container>
  </div>
  <div class="record-card-generic__right">
    <ng-container [ngTemplateOutlet]="right.templateRef"></ng-container>
  </div>
</div>
